import { isThisWeek } from "date-fns";
import React, { useEffect, useState } from "react";
import Aux from './../../hoc/Auxiliary';
import Message from "./Message";

import './Messages.css';

const Messages = (props) => {
    const [isMobile, setIsMobile] = useState(false);
    const [currItems,setCurrItems]= useState([]);    
    useEffect(()=>{
        window.screen.width <=960? setIsMobile(true):setIsMobile(false);
    },[window.screen.width ]);
    useEffect(()=>{     
        if(!!props.items && props.items.length>0){
            let tempIsMobile=false;
            window.screen.width <=960? tempIsMobile=true :tempIsMobile=false;
         
        let baseUrl =window.location.origin;

        let items = props.items.map((item,index) => {
        
            if(index<3){
                let itemUrl=  window.location.pathname.toLowerCase().split('\pages')[0]+ '\pages\\'+ item.LinkFilenameNoMenu; 
               
                return (
                    <div key={item.ID} className="col-lg-4 message-pub card">
                          <div className="message-pub-child">
                         <img src={baseUrl+item.MatalFloatingImage.ImageUrl} width={tempIsMobile? '100%' :'100%'} height={tempIsMobile? 172 :202} alt=""/> 
                         <div className={'card-title'}>
                           <h3 className="col-12">{item.Title}</h3>
                        </div>
               
                        <div className='allNewsLink'>
                            <div className={'card-text card-date'}>
                                {item.PageCreated.split('T')[0].split('/').join('.')}
                            </div>
                            {!!item.LinkFilenameNoMenu ? <a href={baseUrl+itemUrl}  className='my-link' style={{color: "#185EF1"}}    >{CreateDicLanguages().MODContinueReading}
                            <i className={CreateDicLanguages().MODArrowClass}></i></a> :''}
                        </div>
                    </div>

                </div>
                )
            }
            else{
                return false;
            }
        }); 
        setCurrItems(items);
    } },[props.items]);

   let allmessages,arrowDir="";
   if(document.URL.toLowerCase().indexOf("/en/")>0)
   {
        allmessages = "All News";
        arrowDir="fa fa-arrow-right";
   }
   else{
    allmessages = props.allMessagesLink;
    arrowDir="fa fa-arrow-left";
   }
  
    function createMarkup(item) {
        return { __html: item.floatingText };
    }
    function CreateDicLanguages(){
        var dic ={};
        
        dic.he={};
        dic.ar={};
        dic.en={};
        dic.he["MODContinueReading"]="המשך קריאה";
        dic.he["MODArrowClass"]="fa fa-arrow-left";
        
        dic.ar["MODContinueReading"]="متابعة القراءة";
        dic.ar["MODArrowClass"]="fa fa-arrow-left";

        dic.en["MODContinueReading"]="Continue Reading";
        dic.en["MODArrowClass"]="fa fa-arrow-right";
                
        if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/he')> -1)
        {
          return dic.he;
        }
        else if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/ar')> -1){
          return dic.ar;
        }
        else{
            return dic.en;
          }
    
      }
 
    return (
        <div className="col-12 col-lg-12 wp-messages">
            <div className='message-title'>
            {/*
                col-lg-12
                col-lg-7 */}
                <h2 className="wp-title col-6 col-lg-7" role="heading" aria-level="2">{props.title}</h2>
             
             <div className="message-allNewsLink col-6 col-lg-5">
                 <a className="allNewsLink" href={props.allPages}> {allmessages}  <i className={arrowDir}></i></a>
            </div>    
            </div>
            <div className='message-items col-lg-12'>
            
            {/* <div className="col-0 col-lg-2  d-md-block"></div> */}
            {currItems}
            {/* </div> */}
            </div>
        </div>
    );
}

export default Messages; 